module.exports = __webpack_public_path__ + "media/images/ligweb_no_img-b9f721be18e4386c5576cf4330d5ad6a.jpg";